/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import React, { useEffect, useState } from 'react'
import Select, { components } from "react-select";
import { CustomDropdownIndicator } from './CustomDropdownIndicator'
const HelloBar = () => {

	// const colourStylesRow = {
	// 	dropdownIndicator: styles => ({
	// 		color: '#FFAE12',
	// 	})
	// }

	const [optionsList, setOptionsList] = useState([
		{ value: '1', label: 'Label 1' },
		{ value: '2', label: 'Two' },
	]);

	// const customStyles = {
	// 	//more styles
	// 	dropdownIndicator: (provided, state) => ({
	// 		...provided,
	// 		width: '32.5px', // Adjust the width to fit your image
	// 		height: '20px', // Adjust the height to fit your image
	// 		transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
	// 		padding: '0px',
	// 		justifyContent: 'center',
	// 		fill: 'red !important',
	// 	}),
	// 	// morestyles
	// }

	const customStyles = {
		control: (provided) => ({ // class attribute : class=" css-i32vvf-control"
			...provided,
			background: '#FFFF',
			// display: 'flex',
			// flexWrap: 'nowrap',
			borderColor: '#3999FF',
			borderRadius: '7px',
			borderWidth: '1px',
			// width: '1px',
			fontWeight: 700,
			color: '#3999FF',
			// textDecorationColor: '#3999FF'
		}),
		menu: (provided) => ({ // 'menu' is from the div class too.
			...provided,
			fontWeight: 700,
			// background: 'transparent',
			background: '#FFFF',
			width: '92%',
			color: '#3999FF',
			// textDecorationColor: '#3999FF'
		}),
		singleValue: provided => ({
			...provided,
			color: '#3999FF',
			fontWeight: 700,
		}),
		placeholder: (baseStyles) => ({
			...baseStyles,
			// fontSize: "1em",
			// color: '#0003B1',
			fontWeight: 700,
			// borderColor: '#3999FF'
			color: '#3999FF',
		})
	};

	return (
		<div className="hello-bar m-3">
			<h1>Hello Bar</h1>

			{/* <Select
				styles={customStyles}
				class="flag-drop-down"
				options={optionsList}
				components={{ DropdownIndicator: CustomDropdownIndicator }}
				placeholder={<svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M0 0L5 5L10 0H0Z" fill="#0003B1" />
				</svg>
				}
			/> */}

			{/* styles={{
						placeholder: (baseStyles) => ({
							...baseStyles,
							// fontSize: "1em",
							// color: '#0003B1',
							// fontWeight: 700,,
							borderColor: '#3999FF'
						})
					}} */}

			<div className="row col-4 align-items-center justify-content-start">
				<label className='cmx-form-label'>Choose your project</label>
				<Select
					className="select-style col-12 pl-2 mt-2 mb-3"
					closeMenuOnSelect={false}
					components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
					placeholder={"Choose"}
					styles={customStyles}
					options={optionsList}
				/>
			</div>


			{/* <div className="row col-4 align-items-center justify-content-start">
				<label className='cmx-form-label'>Choose your project</label>
				<select styles={colourStylesRow}
					components={{ Placeholder, DropdownIndicator: CustomDropdownIndicator }}
					className="select-style cmx-form-control col-12 pl-2 mt-2 mb-3"
				>
					<option className="option-style" selected>Choose an option</option>
					<option className="option-style"  >OPTION</option>
				</select>
			</div> */}
		</div>
	)
};

export default HelloBar
